import uuid from 'node-uuid';
import lodash from 'lodash';

export const APPLICATION_MESSAGE_ADD = 'APPLICATION_MESSAGE_ADD';
export const APPLICATION_MESSAGE_ADDMANY = 'APPLICATION_MESSAGE_ADDMANY';
export const APPLICATION_MESSAGE_REMOVE = 'APPLICATION_MESSAGE_REMOVE';
export const APPLICATION_MESSAGE_REMOVE_ALL = 'APPLICATION_MESSAGE_REMOVE_ALL';

const DEFAULT_TTL = 3000; //three seconds

function replaceWord(message) {
    return lodash.replace(message, /study|Study/g, match => {
        return match === 'study' ? 'binder' : 'Binder';
    });
}

export function addApplicationMessage(type, message, messageData) {
    return {
        type: APPLICATION_MESSAGE_ADD,
        payload: {
            id: uuid.v4(),
            type,
            message: ['download'].includes(type) ? message : replaceWord(message),
            messageData: {
                ttl: DEFAULT_TTL,
                timestamp: Date.now(),
                ...messageData
            }
        }
    };
}

export function addApplicationMessages(type, messages) {
    const messagesWithIds = lodash.map(messages, m => ({
        type: type,
        message: ['download'].includes(type) ? m : replaceWord(m),
        messageData: {
            ttl: DEFAULT_TTL,
            timestamp: Date.now(),
            ...m.messageData
        },
        id: uuid.v4()
    }));
    const identifiedMessages = lodash.keyBy(messagesWithIds, 'id');

    return {
        type: APPLICATION_MESSAGE_ADDMANY,
        payload: identifiedMessages
    };
}

export function removeApplicationMessage(messageId) {
    return {
        type: APPLICATION_MESSAGE_REMOVE,
        payload: messageId
    };
}

export function clearApplicationMessages() {
    return {
        type: APPLICATION_MESSAGE_REMOVE_ALL
    };
}

